import { prepareParams, paramsSerializerQs } from '@/helpers/api'
import axiosReportsInstance from '@/plugins/axiosReports'

const ReportsApiService = {
  request(url, params, cfg) {
    const config = { params: prepareParams(params), paramsSerializer: paramsSerializerQs, ...cfg }
    return axiosReportsInstance.get(url, config)
  },
  get(url, params, customConfig = {}) {
    const { loc, signal, ...rest } = params || {}
    const config = {
      params: prepareParams(rest),
      paramsSerializer: paramsSerializerQs,
      signal,
      ...customConfig,
    }
    config.loc = loc
    return axiosReportsInstance.get(url, config)
  },
  postQuery(url, params, customConfig = {}) {
    const { loc, signal, ...rest } = params || {}
    const config = {
      params: prepareParams(rest),
      paramsSerializer: paramsSerializerQs,
      signal,
      ...customConfig,
    }
    config.loc = loc
    return axiosReportsInstance.post(url, null, config)
  },
  getFile(url, params) {
    const config = {
      params: prepareParams(params),
      responseType: 'arraybuffer',
    }
    return axiosReportsInstance.get(url, config)
  },
  postFile(url, data, params = {}) {
    const config = { ...params, headers: { 'Content-Type': 'multipart/form-data' } }
    return axiosReportsInstance.post(url, data, config)
  },
  post(url, payload, params) {
    return axiosReportsInstance.post(url, payload, params)
  },
  update(url, slug, params) {
    return axiosReportsInstance.put(`${url}/${slug}`, params)
  },
  put(url, params) {
    return axiosReportsInstance.put(`${url}`, params)
  },
  putQuery(url, data, query) {
    return axiosReportsInstance.put(`${url}`, data, {params: {...query}})
  },
  patch(url, data, params) {
    return axiosReportsInstance.patch(`${url}`, data, params)
  },
  delete(url, data) {
    return axiosReportsInstance.delete(url, { ...data })
  },
}
export default ReportsApiService
